import { logo, logoImage } from "./HeaderLogo.module.css";
import { Box, Image, useMantineColorScheme } from "@mantine/core";
import { RelativeLink } from "../../components/Link";
import { useBasePath } from "../../hooks/router";
import { WEBSITE_URL } from "../../constants/website";
import { useLocale } from "../../hooks/locale";

export function HeaderIcon() {
  const pathname = useBasePath();
  const locale = useLocale();
  const { colorScheme } = useMantineColorScheme();

  const href = `${WEBSITE_URL}${locale !== "en" ? `/${locale}` : ""}`;

  return (
    <Box visibleFrom="xs">
      {pathname === "/" && (
        <a href={href} className={logo} aria-label="Mapka">
          <Image
            src={colorScheme === "dark" ? "/icon256-dark.png" : "/icon256-light.png"}
            alt="Mapka"
            height="32px"
            fit="scale-down"
            className={logoImage}
          />
        </a>
      )}
      {pathname !== "/" && (
        <RelativeLink href={pathname} className={logo} aria-label="Mapka">
          <Image
            src={colorScheme === "dark" ? "/icon256-dark.png" : "/icon256-light.png"}
            alt="Mapka"
            height="32px"
            fit="scale-down"
            className={logoImage}
          />
        </RelativeLink>
      )}
    </Box>
  );
}
